function cssViewportHeight() {
  document.documentElement.style.setProperty(
    "--w-vh",
    // window.innerHeight * 0.01 + 'px'
    Math.min(
      document.documentElement.clientHeight,
      window.screen.height,
      window.innerHeight
    ) *
      0.01 +
      "px"
  );
}
cssViewportHeight();
window.addEventListener("resize", cssViewportHeight);
